let otClient: OT | null = null;

export type ExceptionEvent = {
  code: number;
  message: string;
};
export type OT = {
  on: (event: string, callback: (event: ExceptionEvent) => void) => void;
  off: (event: string, callback: (event: ExceptionEvent) => void) => void;
};

/**
 * Gets the OpenTok client object with caching.
 * @returns Promise that resolves to the OpenTok client instance
 */
export async function getOT(): Promise<OT> {
  if (!otClient) {
    otClient = await import('@opentok/client').then((OT) => OT.default as OT);
  }
  return otClient as OT;
}
